import { render, staticRenderFns } from "./uploaddownTX.vue?vue&type=template&id=228135ae"
import script from "./uploaddownTX.vue?vue&type=script&lang=js"
export * from "./uploaddownTX.vue?vue&type=script&lang=js"
import style0 from "./uploaddownTX.vue?vue&type=style&index=0&id=228135ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports